/** @format */

// Add your custom JS here.
;(function ($) {
  // Fade in effects
  AOS.init()

  // Smooth anchor scrolling
  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 300,
  })
  const openModal = () => {
    const hash = window.location.hash
    const origin = window.location.origin
    const url = `${origin}/${hash}`
    const href = window.location.href
    if (hash === "#virtualtour" && href === url) {
      if ($("#tourplayer").length) {
        const tourIframe = document.querySelector("#tourplayer")
        const tourPlayer = new Vimeo.Player(tourIframe)

        $(".virtual-tour-popup").addClass("active")
        tourPlayer.play()
      }
    }
  }
  openModal()
  $(window).on("hashchange", openModal)
  // check if page is scrolled from the top for header
  $(document).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $("#wrapper-navbar").addClass("off-top")
    }
    if ($(this).scrollTop() < 50) {
      $("#wrapper-navbar").removeClass("off-top")
    }
  })

  if ($(window).width() < 992) {
    $(".section-nine .usps").wrapInner('<div class="swiper usp-swiper"></div>')

    $(".usp-swiper").wrapInner('<div class="swiper-wrapper"></div>')

    var divs = $(".section-nine .usp")
    for (var i = 0; i < divs.length; i += 6) {
      divs.slice(i, i + 6).wrapAll("<div class='swiper-slide'></div>")
    }

    // Swiper example
    var swiper = new Swiper(".usp-swiper", {
      slidesPerView: 1,
      center: true,
      loop: true,
      pagination: {
        el: ".usp-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>'
        },
      },
      breakpoints: {
        768: {
          spaceBetween: 500,
        },
        1024: {
          spaceBetween: 500,
        },
      },
    })
  }

  if ($(window).width() < 1200) {
    $("#wrapper-navbar .button").on("click", function () {
      $("#wrapper-navbar").removeClass("active")
    })
  }

  // Swiper example
  var swiper = new Swiper(".gallery-swiper", {
    slidesPerView: "auto",
    center: true,
    autoplay: {
      delay: 5000,
    },
    loop: true,
    pagination: {
      el: ".gallery-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>'
      },
    },
    navigation: {
      nextEl: ".gallery-next",
      prevEl: ".gallery-prev",
    },
    breakpoints: {
      768: {
        spaceBetween: 500,
      },
      1024: {
        spaceBetween: 500,
      },
    },
  })

  var popupIndex = 1

  $(".image-group").each(function () {
    var popupSwiper = new Swiper(".popup-swiper-" + popupIndex + "", {
      direction: "vertical",
      loop: true,
      loop: false,

      pagination: {
        el: ".image-group-pagination-" + popupIndex + "",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>'
        },
      },
    })

    popupIndex++

    popupSwiper.on("realIndexChange", function () {
      var slideIndex = popupSwiper.realIndex + 1
      var groupindex = popupSwiper.el
      var groupindexnumber = groupindex.getAttribute("index")

      $(groupindex)
        .parent()
        .parent()
        .siblings()
        .children(".legends")
        .children("#image-group-legends-" + groupindexnumber + "")
        .children()
        .slideUp(function () {
          $(groupindex)
            .parent()
            .parent()
            .siblings()
            .children(".legends")
            .children("#image-group-legends-" + groupindexnumber + "")
            .children("#legend-" + slideIndex + "")
            .slideDown()
        })

      $(".vimeoplayer").each(function () {
        var iframe = $(this)[0]
        var player = new Vimeo.Player(iframe)
        player
          .pause()
          .then(function () {
            // Player is paused
          })
          .catch(function (error) {
            console.error("An error occurred:", error)
          })
      })
    })
  })

  // table hover
  $(".building-row").on("mouseover", function () {
    var currentfloor = $(this).data("floor")

    if (
      $(this).data("floor") !== "undefined" &&
      $(this).data("floor") !== false
    ) {
      $.each(currentfloor.split(",").slice(0), function (index, item) {
        var currentfloor = "#" + item
        $(".building svg").children(currentfloor).addClass("active")
      })
    }
  })

  $(".building-row").on("click", function () {
    var currentfloor = $(this).data("floor")

    if (
      $(this).data("floor") !== "undefined" &&
      $(this).data("floor") !== false
    ) {
      $.each(currentfloor.split(",").slice(0), function (index, item) {
        var currentfloor = "#" + item
        $(".building svg").children(currentfloor).addClass("active")
      })
    }
  })

  $(".building-row").on("mouseout", function () {
    $(".building svg").children().removeClass("active")
  })

  // image hover
  $(".image-building-row").on("mouseover", function () {
    var currentimagefloor = $(this).attr("id")
    $(".building-row").each(function () {
      $('[data-floor*="' + currentimagefloor + '"]').click()
    })
  })

  $(".image-building-row").on("mouseout", function () {
    $(".building svg").children().removeClass("active")
    $(".building-row").removeClass("active")
  })

  // image hover

  $(".image-building-row").on("mouseover", function () {
    var currentimagefloor = $(this).attr("id")
    $(".building-row").each(function () {
      $('[data-floor*="' + currentimagefloor + '"]').addClass("active")
    })
  })

  $(".image-building-row").on("click", function () {
    var currentimagefloorclick = $(this).attr("id")
    $(".building-row").each(function () {
      $('[data-floor*="' + currentimagefloorclick + '"]')
        .find(".plan-popup")
        .addClass("active")
      $('[data-floor*="' + currentimagefloorclick + '"]')
        .find(".image-group-title:first-child")
        .addClass("active")
      $('[data-floor*="' + currentimagefloorclick + '"]')
        .find(".image-group:first-child")
        .addClass("active")
    })
  })

  $(".maps .map").each(function () {
    $(".map-point-category:first-child").addClass("active")
  })

  $(".map-toggles div:first-child").addClass("active")

  $(".map-toggles div:first-child").on("click", function () {
    $(".maps").removeClass("right").addClass("left")
    $(this).siblings().removeClass("active")
    $(this).addClass("active")
  })

  $(".map-toggles div:last-child").on("click", function () {
    $(".maps").removeClass("left").addClass("right")
    $(this).siblings().removeClass("active")
    $(this).addClass("active")
  })

  $(".map-category-name").on("click", function () {
    $(this).parent().siblings().removeClass("active")
    $(this).parent().addClass("active")
  })

  $(".footer-contact .button").on("click", function () {
    $(this).addClass("hide")
    $(".contacts").addClass("active")
  })

  // $(".map-point-category .image").on("click", function () {
  //     $(this).parent().siblings().children('.image').removeClass('scaleme');
  //     $(this).addClass('scaleme');
  // });

  // $(document).on("click", function (e) {
  //     if (!$(e.target).not(".image")) {
  //         $('.map-point-category .image').removeClass('scaleme');
  //     }
  // });

  // downloads
  $(".page-template-frontpage .download-button").on("click", function (e) {
    if ($("body").hasClass("subscribed")) {
      var currentfileLink = $(this).attr("downloadlink")
      var currentfileName = $(this).attr("filename")
      $("#saentysfdbm").attr("href", currentfileLink)
      $("#saentysfdbm").attr("download", currentfileName)
      $("#saentysfdbm")[0].click()
    } else {
      var currentdownload = $(this).siblings("h4").text()
      $(".download-popup h3").text(currentdownload)
      $(".download-popup-shadow").addClass("active")
      $(".download-popup").addClass("active")
      var currentfileLink = $(this).attr("downloadlink")
      var currentfileName = $(this).attr("filename")
      $("#saentysfdbm").attr("href", currentfileLink)
      $("#saentysfdbm").attr("download", currentfileName)
      $(document).on("gform_confirmation_loaded", function (e, form_id) {
        $("body").addClass("subscribed")
        $("#saentysfdbm")[0].click()
      })
    }
  })

  $(".download-popup .close, .download-popup-shadow").on("click", function (e) {
    $(".download-popup-shadow").removeClass("active")
    $(".download-popup").removeClass("active")
  })

  $(".viewplan").on("click", function (e) {
    $(this).siblings(".plan-popup").addClass("active")
    $(this)
      .siblings(".plan-popup")
      .find(".image-group-title:first-child")
      .addClass("active")
    $(this)
      .siblings(".plan-popup")
      .find(".image-group:first-child")
      .addClass("active")
  })

  $(".plan-popup .close").on("click", function (e) {
    $(".plan-popup").removeClass("active")
    $(".image-group-title").removeClass("active")
    $(".image-group").removeClass("active")
  })

  $(".image-group-title").on("click", function (e) {
    $(".image-group-title").removeClass("active")
    $(this).addClass("active")
    $(".image-group").removeClass("active")
    var groupindex = $(this).attr("groupindex")
    $(this)
      .parent()
      .parent()
      .siblings(".image-groups")
      .children("." + groupindex)
      .addClass("active")
  })

  $(".menu-icon").on("click", function (e) {
    $("#wrapper-navbar").addClass("active")
  })

  $("#wrapper-navbar .close").on("click", function (e) {
    $("#wrapper-navbar").removeClass("active")
  })

  $("#wrapper-navbar li").on("click", function (e) {
    $("#wrapper-navbar").removeClass("active")
  })

  if ($(window).width() < 992) {
    var t = 0
    $(".map-category-points").each(function () {
      if ($(this).outerHeight() > t) {
        var highestone = $(this).outerHeight()

        t = highestone
      }

      $(".map-points").css("padding-bottom", highestone)
    })
  }

  // legend thingsss
  $(".image-group-title").on("click", function (e) {
    var imagegroupindex = $(this).attr("index")

    $(this)
      .parent()
      .siblings(".legends")
      .children()
      .slideUp(function () {
        $(this)
          .siblings("#image-group-legends-" + imagegroupindex + "")
          .slideDown()
      })
  })

  // TOURPLAYR
  if ($("#tourplayer").length) {
    const tourIframe = document.querySelector("#tourplayer")
    const tourPlayer = new Vimeo.Player(tourIframe)

    $(".tour-toggle").on("click", function () {
      $(".virtual-tour-popup").addClass("active")
      tourPlayer.play()
    })

    $(".virtual-tour-popup .close").on("click", function () {
      $(".virtual-tour-popup").removeClass("active")
      tourPlayer.pause()
      history.replaceState({}, document.title, ".")
    })
  }
})(jQuery)

//125
